<template>
  <ul class="rightNav">
    <li>
      <el-dropdown @command="handleCommand2">
            
        <span class="el-dropdown-link">
          {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh">中文</el-dropdown-item>
          <el-dropdown-item command="ja">日本語</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      &nbsp;&nbsp;&nbsp;


      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-user"></i>&nbsp;
          {{
            accountInfo.userName
          }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="ROUTER_PATH.ACCOUNT_INFO"
            ><i class="el-icon-user"></i>{{this.$t('menu.account')}}</el-dropdown-item
          >
          <el-dropdown-item :command="ROUTER_PATH.ACCOUNT_RESET_PASSWORD"
            ><i class="el-icon-key"></i>{{this.$t('menu.password')}}</el-dropdown-item
          >
          <el-dropdown-item :command="ROUTER_PATH.LOGIN_OUT"
            ><i class="el-icon-switch-button"></i>{{this.$t('menu.logout')}}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";
export default {
  name: "HeaderRightNav",
  data: () => {
    return {
      ROUTER_PATH: ROUTER_PATH
    };
  },
  mounted() {
    if (this.$i18n.locale === "zh") {
      this.lang = "中文";
    } else {
      this.lang = "日本語";
    }
  },
  methods: {
    handleCommand(command) {
      this.$router.push(command);
    },
    handleCommand2(command) {
      if (command == "zh") {
        this.lang = "中文";
        this.$i18n.locale = "zh";
        //this.$cookie.set("lang","zh");
      } else {
        this.lang = "日本語";
        this.$i18n.locale = "ja";
        //this.$cookie.set("lang","jp");
      }
    },
  },
  computed: {
    ...mapState(["accountInfo"])
  }
};
</script>

<style>
.rightNav {
  display: flex;
  list-style: none;
}
.rightNav svg {
  margin-right: 8px;
}
.rightNav .active span {
  color: #0055f9;
}
.rightNav .active span:hover {
  color: #0055f9;
}
.rightNav li {
  color: #999;
  cursor: pointer;
  font-size: 14px;
  margin-left: 30px;
}
.rightNav li span {
  font-size: 14px;
  color: #999;
}
.rightNav li:hover {
  color: #333;
}
.rightNav li span:hover {
  color: #333;
}
</style>
